import { useState } from "react"

interface StepContentProps {
  step: any
}

export default function StepContent({ step }: StepContentProps) {
  const [activeTab, setActiveTab] = useState("description")

  if (!step) {
    return null
  }

  const renderContent = () => {
    if (activeTab === "description") {
      return (
        <div className="text-sm text-gray-700">
          {typeof step.description === "string" ? (
            <div dangerouslySetInnerHTML={{ __html: step.description }} />
          ) : (
            step.description
          )}
        </div>
      )
    } else if (activeTab === "tips") {
      return (
        <div className="space-y-4">
          {typeof step.tips === "string" ? <div dangerouslySetInnerHTML={{ __html: step.tips }} /> : step.tips}
        </div>
      )
    } else if (activeTab === "examples") {
      return (
        <div className="text-sm">
          {typeof step.examples === "string" ? (
            <div dangerouslySetInnerHTML={{ __html: step.examples }} />
          ) : (
            step.examples
          )}
        </div>
      )
    }
    return null
  }

  return (
    <div className="bg-white rounded-lg shadow-lg mt-6">
      <div className="bg-blue-600 p-4 text-white rounded-t-lg">
        <h3 className="text-lg font-bold flex items-center gap-2">
          <span>{step.icon || "📄"}</span>
          <span>{step.title}</span>
        </h3>
      </div>

      <div className="flex border-b">
        <button
          onClick={() => setActiveTab("description")}
          className={`flex-1 p-3 text-sm ${
            activeTab === "description" ? "bg-blue-50 font-bold text-blue-600" : "text-gray-600"
          }`}
        >
          📝 Uitleg
        </button>
        <button
          onClick={() => setActiveTab("tips")}
          className={`flex-1 p-3 text-sm ${
            activeTab === "tips" ? "bg-blue-50 font-bold text-blue-600" : "text-gray-600"
          }`}
        >
          💡 Tips
        </button>
        <button
          onClick={() => setActiveTab("examples")}
          className={`flex-1 p-3 text-sm ${
            activeTab === "examples" ? "bg-blue-50 font-bold text-blue-600" : "text-gray-600"
          }`}
        >
          ✨ Voorbeelden
        </button>
      </div>

      <div className="p-4">{renderContent()}</div>
    </div>
  )
}
